<template>
  <v-container>
    <v-layout
      text-center
      wrap
    >
      <v-flex xs12>
        <v-avatar
          size="200"
          >
        <v-img
          :src="require('../assets/avatar.jpg')"
          class="my-3"
          style="border-radius: 50% !important;"
          contain
        ></v-img>
        </v-avatar>
    </v-flex>

      <v-flex mb-4>
        <h1 class="intro font-weight-bold mb-3">
          Hey, I'm Brittany!
        </h1>
        <p class="subheading font-weight-regular">
          I'm a Graphic Designer, Artist, Full-Time Twitch Streamer, &amp; 
          <span class="twitch">Emote Designer</span> excited to bring your ideas
          to life!
        </p>

            <v-layout
      justify-center
      wrap
    >
      <v-btn
        v-for="link in links"
        :key="link"
        @click="openLink(link.href)"
        color="pink"
        text
        rounded
        class="my-2"
      >
          <font-awesome-icon
            :icon="['fab', link.icon]"
          ></font-awesome-icon>
      </v-btn>
    </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          icon:'twitch',
          href: 'https://twitch.tv/attackongamez'
        },
        {
          icon:'twitter',
          href: 'https://twitter.com/attackongamez'
        },
        {
          icon:'instagram',
          href: 'https://instagram.com/brittanysdesigns'
        },
        {
          icon:'discord',
          href: 'https://t.co/ewXmWg2D0n?amp=1'
        },
        {
          icon:'patreon',
          href: 'https://patreon.com/brittanysdesigns'
        },
        {
          icon:'etsy',
          href: 'https://etsy.com/shop/iluffsasuke'
        },
      ],
    }
  }
}
</script>

<style scoped>
.intro {
  font-family: 'Pacifico';
}
</style>